export default "__VITE_ASSET__CPK07GJ4__"